export default __webpack_public_path__ + "static/media/Dhan-Labh-Brochure.465343c9.pdf";